// extracted by mini-css-extract-plugin
module.exports = {"root":"LabelWithDescription_root__2pxav","label":"LabelWithDescription_label__2bW6U","description":"LabelWithDescription_description__13PRZ"};